import { DeleteRoute } from '@/javascript/domain/usecases/maps/delete-route'
import { AccessDeniedError, UnexpectedError, ValidationError } from '@/javascript/domain/errors'
import { HttpClient, HttpStatusCode } from '@/javascript/data/protocols/http'

export class RemoteDeleteRoute implements DeleteRoute {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteDeleteRoute.Response>
  ) {}

  async delete (id: number): Promise<void> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${id}`,
      method: 'delete'
    })
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.noContent: return
      case HttpStatusCode.unprocessableEntity: throw new ValidationError({ message: httpResponse.body.error })
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteDeleteRoute {
  export type Response = {
    error?: string
  }
}
